<template>
    <v-card>
        <v-card-title>
            <v-layout justify-space-around wrap>
              <v-flex xs1>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      color="primary"
                      small
                      @click="function () {
                        if (step === 1) $emit('fechar')
                        else if (step === 2) step = 3
                        else step = 1
                      }"
                    >
                      <v-icon>{{step !== 1 ? 'arrow_back' : 'close'}}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{step !== 1 ? 'Voltar' : 'Fechar'}}</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs9>
                <h1 class="text-xs-center">{{titulo}}</h1>
              </v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    color="primary"
                    small
                    v-if="step===1"
                    @click="step = 3"
                  >
                    <v-icon>list</v-icon>
                  </v-btn>
                </template>
                <span>Cashs Lidos</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    color="primary"
                    small
                    v-if="step===1"
                    @click="step = 4"
                  >
                    <v-icon>history</v-icon>
                  </v-btn>
                </template>
                <span>Histórico de compras de CashPosto</span>
              </v-tooltip>
            </v-layout>
        </v-card-title>
        <v-alert
            :value="true"
            type="error"
            style="font-size: 1.2em"
            class="pa-2"
            v-if="alerta"
        >
              Usuário não encontrado
        </v-alert>
        <v-divider></v-divider>
        <v-card-text>
          <v-stepper v-model="step" style="box-shadow:none;">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 ma-0">
                <v-tabs
                  v-model="tabs"
                  grow
                  color="transparent"
                  slider-color="primary"
                >
                  <v-tab>Por ID</v-tab>
                  <v-tab>Por CPF</v-tab>
                </v-tabs>
                <v-form lazy-validation v-model="valid" ref="form">
                  <v-tabs-items v-model="tabs">
                    <v-tab-item lazy>
                      <v-text-field
                          v-if="tabs == 0"
                          v-model="id_pessoa"
                          :loading="loading"
                          box
                          outline
                          color="primary"
                          label="Digite o ID do usuário"
                          :rules="[
                            (v) => !!v || 'Esse campo é obrigatório'
                          ]"
                      />
                    </v-tab-item>
                    <v-tab-item lazy>
                      <v-text-field
                          v-if="tabs == 1"
                          v-model="cpf"
                          :loading="loading"
                          box
                          outline
                          color="primary"
                          label="Digite o CPF do usuário"
                          mask="###.###.###-##"
                          :rules="[
                            (v) => !!v || 'Esse campo é obrigatório'
                          ]"
                      />
                    </v-tab-item>
                  </v-tabs-items>
                  <h3 v-if="pessoa" class="text-xs-center success--text mb-3">Nome do usuário {{ pessoa.nome }}</h3>
                  <v-text-field
                      prefix="R$"
                      v-model.lazy="valor"
                      v-money="money"
                      :loading="loading"
                      outline
                      color="primary"
                      label="Valor"
                      :rules="[
                        v => verificar(v) || 'Valor Inválido'
                      ]"
                  />
                  <v-text-field
                      v-model="acrescimo"
                      :loading="loading"
                      box
                      outline
                      color="primary"
                      label="Acréscimo"
                      type="number"
                      suffix="%"
                      :rules="[
                        (v) => v > -1 || 'Valor Inválido.'
                      ]"
                  />
                  <v-select
                    v-model="tipo_pagamento"
                    :loading="loading"
                    :items="tipos_pagamentos"
                    item-text="descricao"
                    item-value="id_tipo_pagamento"
                    box
                    outline
                    color="primary"
                    label="Selecio o tipo de pagamento"
                    :rules="[
                      (v) => !!v || 'Esse campo é obrigatório'
                    ]"
                  />
                  <h4 v-if="pessoa" class="text-xs-center mb-3">
                    O Cliente {{ pessoa.nome }} pagará {{ valor }}{{ acrescimo && acrescimo > 0 ? ` e ganhá ${adicional} de adicional` : '' }}
                  </h4>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0 ma-0">
                <template v-if="cashSelecionado">
                  <v-layout justify-center>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <img
                            :src="require(`@/assets/cashposto_green.svg`)"
                            style="width: 10em"
                          />
                        </span>
                      </template>
                      <span>Cash Posto</span>
                    </v-tooltip>
                  </v-layout>
                  <v-layout wrap justify-space-between fill-height style="font-size: 1.1em">
                    <v-flex xs6>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Nome do cliente: <b>{{ cashSelecionado.usuario_beneficiado.pessoa.nome_completo }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          ID: <b>{{ cashSelecionado.usuario_beneficiado.pessoa.id_pessoa }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Valor: <b>{{ cashSelecionado.valor  | currency({ fractionCount: 2 }) }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Código: <b>{{ cashSelecionado.numero }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Data: <b>{{ cashSelecionado.data_gerado.split("-").reverse().join("/") }}</b>
                      </h4>
                    </v-flex>
                  </v-layout>
                </template>
              </v-stepper-content>
              <v-stepper-content step="3" class="pa-0 ma-0">
                <v-list three-line class="pt-0">
                  <template v-for="(cash, index) in cashsRetirado">
                    <v-divider v-if="index > 0" :key="`${index}div`" inset></v-divider>
                    <v-list-tile
                      avatar
                      :key="`${index}l`"
                      @click="selectCash(cash)"
                    >
                      <v-list-tile-action>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <img
                                :src="require(`@/assets/cashposto_green.svg`)"
                                style="width: 2em"
                              />
                            </span>
                          </template>
                          <span>Cash retirado</span>
                        </v-tooltip>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ cash.usuario_beneficiado.pessoa.nome_completo }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                        >
                          Valor retirado:
                          {{ cash.valor | currency({ fractionCount: 2 }) }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Data de retirada:
                            {{
                              cash.data_inativado.split("-").reverse().join("/")
                            }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout column align-center justify-center fill-height>
                          <v-icon size="45">face</v-icon>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
                <v-layout justify-space-between v-if="pages !== 0">
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="pagination.page--"
                      color="primary"
                      :disabled="pagination.page == 1"
                    >
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  </v-flex>
                  <v-flex xs9>
                    <v-layout justify-center>
                      <v-avatar>
                        <v-btn icon small color="primary">
                          {{pagination.page}}
                        </v-btn>
                      </v-avatar>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="pagination.page++"
                      :disabled="pagination.page == pages"
                      color="primary"
                    >
                      <v-icon>arrow_forward</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step="4" class="pa-0 ma-0">
                <v-layout justify-center>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    lazy
                    transition="slide-y-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn flat small v-on="on">
                        <span class="secondary--text headline font-weight-medium">{{date}}</span>
                      </v-btn>
                    </template>
                    <v-date-picker v-model="new_date" no-title scrollable color="primary" locale="pt-br"></v-date-picker>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="ID do usuário"
                    solo
                    type="number"
                    v-model="id_pessoa"
                    color="primary"
                  />
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        round
                        dark
                        small
                        color="primary"
                        @click="selecionarFrentista = true"
                        v-on="on"
                      >
                        {{ frentistaSelecionado.nome }}
                      </v-btn>
                    </template>
                    <span>
                      Alterar Frentista
                    </span>
                  </v-tooltip>
                </v-layout>
                <v-list three-line class="pt-0">
                  <template v-for="(compra, index) in comprasCashPosto">
                    <v-divider v-if="index > 0" :key="`${index}div`" inset></v-divider>
                    <v-list-tile
                      avatar
                      :key="`${index}l`"
                    >
                      <v-list-tile-action>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <img
                                :src="require(`@/assets/cashposto_green.svg`)"
                                style="width: 2em"
                              />
                            </span>
                          </template>
                          <span>CashPosto Comprado</span>
                        </v-tooltip>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ compra.cliente.nome_completo }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                        >
                          ID do Usuário:
                          {{ compra.cliente.id_pessoa }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Data de retirada:
                            {{
                              compra.data_compra.split("-").reverse().join("/")
                            }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <b class="light-green--text lighten-1">{{ compra.valor_total | currency({ fractionCount: 2 }) }}</b>
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Frentista:
                            {{
                              compra.frentista.nome
                            }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Matrícula:
                            {{
                              compra.frentista.matricula
                            }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout column align-center justify-center fill-height>
                          <v-icon size="45">face</v-icon>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
                <v-layout justify-space-between v-if="comprasCashPosto.length > 0">
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="paginationCash.page--"
                      color="primary"
                      :disabled="paginationCash.page == 1"
                    >
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  </v-flex>
                  <v-flex xs9>
                    <v-layout justify-center>
                      <v-avatar>
                        <v-btn icon small color="primary">
                          {{paginationCash.page}}
                        </v-btn>
                      </v-avatar>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="paginationCash.page++"
                      :disabled="paginationCash.page == pagesCompras"
                      color="primary"
                    >
                      <v-icon>arrow_forward</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-text v-if="step===1">
            <v-layout justify-space-around wrap class="mb-2">
                <v-flex xs9>
                    <h6
                        class="mb-2 text-xs-center"
                        style="
                            font-size: 1.1em;
                            margin-left: 9em;
                        "
                    >
                        Digite o PIN do frentista responsável
                    </h6>
                </v-flex>
                <v-flex xs3>
                    <v-btn
                        round
                        color="primary"
                        small
                        @click="selecionarFrentista = true"
                    >
                        Alterar frentista
                    </v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-icon size="40">engineering</v-icon>
                </v-flex>
                <v-flex xs10>
                    <h4>Lido por: {{frentistaSelecionado.nome}}</h4>
                    <h4>Matricula: {{frentistaSelecionado.matricula}}</h4>
                </v-flex>
            </v-layout>
            <Pin v-if="!autenticado" :frentista="frentistaSelecionado" @autenticado="autenticado = true"/>
            <h3 v-else class="success--text text-xs-center mt-3 mb-3">A leitura já pode ser realizada</h3>
        </v-card-text>
        <v-card-actions v-if="step !== 4">
          <v-btn
            color="primary"
            block
            class="mb-1"
            :disabled="
              (step === 1 && (!autenticado || !frentistaSelecionado.controle_cashposto)) ||
              (step === 2 && !autenticado)
            "
            @click="function () {
              if (step === 1) comprarCashPosto()
              else if (step === 3) usarCashPosto()
            }"
            v-if="step !== 3"
          >
            <v-icon v-if="step===1" class="mr-1">search</v-icon>
            {{ step === 1 ? 'Confirmar' : step === 3 ? 'Marcar como retirado' : 'Confirmar' }}
          </v-btn>
        </v-card-actions>
        <v-dialog
            v-if="selecionarFrentista"
            v-model="selecionarFrentista"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <selecionar-frentista
                @fechar="selecionarFrentista = false, autenticado = false"
            />
        </v-dialog>
    </v-card>
</template>

<script>

import Pin from '@/components/Pin'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'
import { VMoney } from 'v-money'
export default {
  components: { Pin, SelecionarFrentista },
  directives: { money: VMoney },
  data: () => ({
    date: new Date().toLocaleDateString(),
    new_date: new Date().toISOString().substr(0, 10),
    menu: false,
    step: 1,
    pesquisa: undefined,
    id_pessoa: undefined,
    cashs: [],
    valid: false,
    cashsRetirado: [],
    totalItens: 0,
    cashSelecionado: undefined,
    tipo_pagamento: undefined,
    acrescimo: 0,
    tabs: 0,
    valor: '0,00',
    cpf: undefined,
    selecionarFrentista: false,
    tipos_pagamentos: [],
    autenticado: false,
    pessoa: null,
    alerta: false,
    totalItensCompra: 0,
    comprasCashPosto: [],
    pagination: {
      rowsPerPage: 5,
      page: 1
    },
    paginationCash: {
      rowsPerPage: 5,
      page: 1
    },
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    }
  }),
  beforeMount () {
    this.pegarTiposDePagamento()
    if (this.step === 4) this.pegarComprasCashPosto()
  },
  computed: {
    titulo () {
      if (this.step === 1) return 'Comprar Cash Posto'
      else if (this.step === 2) return 'Detalhes do Cash Posto'
      else if (this.step === 4) return 'Compras de Cash Posto'
      else return 'Cash Posto lidos'
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      let count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    pagesCompras () {
      let count = this.totalItensCompra
      if (this.paginationCash.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.paginationCash.rowsPerPage)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    adicional () {
      const valor = this.converterValor(this.valor)
      if (!this.acrescimo) return (0).toFixed(2)
      else if (valor <= 0) return (0).toFixed(2)
      return (valor * (this.acrescimo / 100)).toFixed(2).toString().replace('.', ',')
    }
  },
  watch: {
    pagination: {
      handler (val, oldval) {
        this.carregarCashRetirado()
      },
      deep: true
    },
    paginationCash: {
      handler (val, oldval) {
        this.pegarComprasCashPosto()
      },
      deep: true
    },
    tabs () {
      this.pesquisa = undefined
    },
    step (val) {
      if (val === 3) this.carregarCashRetirado()
      else if (val === 4) this.pegarComprasCashPosto()
    },
    id_pessoa (val) {
      if (val) {
        if (this.step === 1) this.pegarPessoaPorId(false)
      } else {
        this.pessoa = undefined
      }
      if (this.step === 4) this.pegarComprasCashPosto()
    },
    cpf (val) {
      if (val && val.length === 11) {
        if (this.step === 1) this.pegarPessoaPorId(true)
      } else {
        this.pessoa = undefined
      }
    },
    new_date (val) {
      this.menu = false
      if (val) {
        this.formatDate(val)
        this.pegarComprasCashPosto()
      }
    },
    frentistaSelecionado (val) {
      if (val) {
        this.pegarComprasCashPosto()
      }
    }
  },
  methods: {
    formatDate (date) {
      this.date = date
        .split('-')
        .reverse()
        .join('/')
    },
    selectCash (cash) {
      this.cashSelecionado = cash
      this.step = 2
    },
    carregarCashRetirado () {
      this.$store.dispatch('historicoCash', {
        page: this.pagination.page,
        frentista: this.frentistaSelecionado.id_frentista
      }).then(value => {
        this.cashsRetirado = value.results
        this.totalItens = value.count
      })
    },
    pegarCashPosto () {
      const parametros = {
        data: {
          cnpj: this.posto.cnpj,
          id_frentista: this.frentistaSelecionado.id_frentista
        },
        method: 'GET'
      }
      if (this.tabs === 0) parametros.data.id_pessoa = this.pesquisa
      else parametros.data.numero = this.pesquisa
      this.$store.dispatch('cashPosto', parametros).then(list => {
        this.cashs = list
      })
    },
    usarCashPosto () {
      const parametros = {
        data: {
          id_voucher: this.cashSelecionado.id_voucher,
          id_frentista: this.frentistaSelecionado.id_frentista,
          cnpj: this.posto.cnpj
        },
        method: 'PUT'
      }
      this.$store.dispatch('cashPosto', parametros).then(() => {
        this.cashSelecionado = undefined
        this.step = 1
      })
    },
    comprarCashPosto () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('comprarCashPosto', {
          valor: this.converterValor(this.valor),
          id_pessoa: this.id_pessoa ? this.id_pessoa : null,
          cpf: this.cpf ? this.cpf : null,
          id_tipo_pagamento: this.tipo_pagamento,
          id_frentista: this.frentistaSelecionado.id_frentista,
          acrescimo: !this.acrescimo || this.acrescimo < 1 ? null : this.acrescimo
        }).then(() => {
          this.valor = '0,00'
          this.id_pessoa = undefined
          this.pessoa = null
          this.tipo_pagamento = undefined
          this.autenticado = false
          this.acrescimo = 0
        })
      } else {
        this.$store.dispatch('setError', { message: 'Dados Inválidos!' })
      }
    },
    pegarTiposDePagamento () {
      this.$store.dispatch('pegarTiposDePagamento').then(json => {
        this.tipos_pagamentos = json.filter((tp) => tp.referencia !== 'carteira_digital' && tp.referencia !== 'cashback')
      })
    },
    pegarPessoaPorId (isCPF) {
      const data = {
        id_frentista: this.frentistaSelecionado.id_frentista
      }

      if (isCPF) data.cpf = this.cpf
      else data.id_pessoa = this.id_pessoa

      this.$store.dispatch('pegarPessoaPorId', data).then(json => {
        this.alerta = false
        this.pessoa = json
      }).catch(() => {
        this.alerta = true
        this.pessoa = undefined
      })
    },
    converterValor (valor) {
      return Number(valor.replaceAll('.', '').replace(',', '.'))
    },
    verificar (valor) {
      if (!valor) return false
      if (valor === null) return false
      if (this.converterValor(valor) <= 0) return false
      return true
    },
    pegarComprasCashPosto () {
      const data = {
        frentista: this.frentistaSelecionado.id_frentista,
        page: this.paginationCash.page,
        data_compra: this.new_date
      }
      if (this.id_pessoa) data.cliente__pessoa__id_pessoa = this.id_pessoa
      this.$store.dispatch('pegarComprasCashPosto', data).then(json => {
        this.comprasCashPosto = json.results.compras
        this.totalItensCompra = json.count
      })
    }
  }
}
</script>
